import { gql } from '@apollo/client';

export const getPricePointDropdownValues = gql`
    query getPricePointDropdownValues(
        $attributeType: SamyaString!
        $dimension: SamyaString
        $searchKeyword: SamyaString
        $filters: JSONString
        $timePeriod: JSONString!
        $limit: Int
        $offset: Int!
    ) {
        getPricePointDropdownValues(
            attributeType: $attributeType
            dimension: $dimension
            searchKeyword: $searchKeyword
            timePeriod: $timePeriod
            filters: $filters
            limit: $limit
            offset: $offset
        ) {
            attributeType
            values
            count
        }
    }
`;

export const getPricePointChartData = gql`
    query getPricePointGraphData(
        $attributeType: SamyaString!
        $metricType: SamyaString
        $filters: JSONString
        $timePeriod: JSONString!
        $customThresholds: Boolean!
        $yAxisValue: SamyaString!
        $priceRange: [Float]
        $batchSize: Float
        $customThresholdsLst: [Float]
        $priceType: String!
    ) {
        getPricePointGraphData(
            attributeType: $attributeType
            metricType: $metricType
            filters: $filters
            timePeriod: $timePeriod
            yAxisValue: $yAxisValue
            customThresholds: $customThresholds
            priceRange: $priceRange
            batchSize: $batchSize
            customThresholdsLst: $customThresholdsLst
            priceType: $priceType
        ) {
            legendsLst
            data {
                bucketNum
                attributeList {
                    attributeName
                    totalSales
                    contribution
                }
                pricePoints
                bucketContribution
            }
        }
    }
`;

export const getDefaultTableData = gql`
    query getDefaultTableData(
        $attributeType: SamyaString!
        $metricType: SamyaString
        $filters: JSONString
        $timePeriod: JSONString!
        $customThresholds: Boolean!
        $priceRange: [Float]
        $yAxisValue: SamyaString!
        $batchSize: Float
        $customThresholdsLst: [Float]
        $priceType: String!
    ) {
        getDefaultTableData(
            attributeType: $attributeType
            metricType: $metricType
            filters: $filters
            timePeriod: $timePeriod
            customThresholds: $customThresholds
            priceRange: $priceRange
            yAxisValue: $yAxisValue
            batchSize: $batchSize
            customThresholdsLst: $customThresholdsLst
            priceType: $priceType
        ) {
            pricePointsLst
            label
            values
            isExpandable
            nestedIndex
        }
    }
`;

export const getDrilldownTableData = gql`
    query getDrilldownTableData(
        $attributeType: SamyaString!
        $metricType: SamyaString
        $filters: JSONString
        $timePeriod: JSONString!
        $yAxisValue: SamyaString!
        $pricePoints: [Float]
        $priceType: String!
    ) {
        getDrilldownTableData(
            attributeType: $attributeType
            metricType: $metricType
            filters: $filters
            yAxisValue: $yAxisValue
            timePeriod: $timePeriod
            pricePoints: $pricePoints
            priceType: $priceType
        ) {
            data
        }
    }
`;

export const getThresholdRange = gql`
    query getPricePointGraphSliderRanges($filters: JSONString, $timePeriod: JSONString!, $priceType: String!) {
        getPricePointGraphSliderRanges(filters: $filters, timePeriod: $timePeriod, priceType: $priceType) {
            maxPricePu
            minPricePu
            maxPricePeq
            minPricePeq
        }
    }
`;
